import Breakpoint from './breakpoint';

const getCurrentBreakpoint = () => {
  if (window.innerWidth >= Breakpoint.XXL.minWidth) {
    return Breakpoint.XXL;
  } else if (window.innerWidth >= Breakpoint.XL.minWidth) {
    return Breakpoint.XL;
  } else if (window.innerWidth >= Breakpoint.LG.minWidth) {
    return Breakpoint.LG;
  } else if (window.innerWidth >= Breakpoint.MD.minWidth) {
    return Breakpoint.MD;
  } else if (window.innerWidth >= Breakpoint.SM.minWidth) {
    return Breakpoint.SM;
  }

  return Breakpoint.XS;
};

const responsiveItem = (onNewBreakpoint) => {
  let current = getCurrentBreakpoint();

  const onResize = () => {
    const breakpoint = getCurrentBreakpoint();
    if (breakpoint !== current) {
      current = breakpoint;
      onNewBreakpoint(current);
    }
  };

  window.addEventListener('resize', onResize);
  onNewBreakpoint(current);
};

export default responsiveItem;
